import React from 'react'
import { Typography, Stack, Chip, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'
import AppShell from '../components/layout/AppShell'
import { Surface } from '../components/ui/Surface'

/**
 * Historique des scans de l'employé connecté.
 * Le contenu est encore un exemple statique — seule la présentation change.
 */
export const HistoryView = () => {
  const navigate = useNavigate()

  const entries = [
    {
      id: 1,
      ticketName: 'Admission générale',
      ticketNumber: '4540',
      result: 'INVALIDE',
      reason: 'Le billet est déjà sur le site',
      isValid: false,
    },
  ]

  return (
    <AppShell
      title="Mon historique"
      subtitle="Scans effectués sur cet appareil"
      leading={
        <IconButton onClick={() => navigate('/scan')} aria-label="Retour" edge="start">
          <ArrowBackIcon />
        </IconButton>
      }
    >
      <Stack spacing={1.25}>
        {entries.map((entry) => (
          <Surface key={entry.id} padding={1.75}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={1}
            >
              <Stack sx={{ minWidth: 0 }}>
                <Typography variant="subtitle1">{entry.ticketName}</Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  N° {entry.ticketNumber}
                </Typography>
              </Stack>
              <Chip
                size="small"
                label={entry.result}
                color={entry.isValid ? 'success' : 'error'}
                sx={{ flexShrink: 0 }}
              />
            </Stack>
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
              {entry.reason}
            </Typography>
          </Surface>
        ))}
      </Stack>
    </AppShell>
  )
}

export default HistoryView
